export const HUDDLE_PANEL_DEFAULT_WIDTH = 720;
export const HUDDLE_PANEL_DEFAULT_HEIGHT = 520;
export const HUDDLE_PANEL_MIN_WIDTH = 480;
export const HUDDLE_PANEL_MIN_HEIGHT = 360;
